import * as React from "react";
import { ServingIndicator } from "../../ServingIndicator";
export var renderTeam = function (event, onServe, componentPrefix) {
    return React.createElement("div", { className: "rj-ev-list__" + componentPrefix + "__section-item rj-ev-list__" + componentPrefix + "__team-" + onServe + "-name", "data-uat": "div-ev-list-" + componentPrefix + "-team-name" },
        React.createElement(ServingIndicator, { onServe: onServe, event: event }),
        React.createElement("span", { className: "rj-ev-list__name-text", "data-uat": "span-ev-list-name-text" }, event["team" + onServe + "name"]));
};
//# sourceMappingURL=renderTeam.js.map